export enum PerimetreEnum {
  operationnel = "operationnel",
  technique = "technique"
}